import angular from 'angular';
import { WhatsAppDisconnectedReminderPill } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-whatsapp-disconnected-reminder';

angular.module(moduleName, []).directive('whatsappDisconnectedReminder', [
    'Backoffice',
    '$state',
    (Backoffice, $state) => ({
        restrict: 'E',
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], WhatsAppDisconnectedReminderPill, {
                onClick: () => $state.go('app.sportclub-wpp-integration'),
            });

            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
